import { getPassengersTranslation } from "@app/helpers/translations";
import { getFromOptionsMatriceFirstCoordinateForATripId } from "@app/modules/results/selectors/leg-cards/get-options";
import type { TranslatorService } from "@app/services/translator";
import type { TripOption, TripOptionsMatrix } from "@app/types/results-types";
import type { SearchInfo } from "@app/types/search-types";

export function optionsDisplay(
  translator: TranslatorService,
  search: SearchInfo,
  selected_trip: TripOption | undefined,
  leg_card_options_matrix: TripOptionsMatrix
) {
  const passengers = getPassengersTranslation(translator, search);
  const selected_class_name = selected_trip?.class_name;
  const selected_fare_name = selected_trip?.fare_name || "";

  const [matrix_class_index] = getFromOptionsMatriceFirstCoordinateForATripId(
    leg_card_options_matrix,
    selected_trip?.trip_id ?? ""
  );

  const row =
    matrix_class_index !== undefined
      ? leg_card_options_matrix[matrix_class_index]
      : [];
  const display_fare =
    // @ts-expect-error TS18048 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    row.length > 1;
  const display_class = leg_card_options_matrix.length > 1;

  return [
    passengers,
    display_class ? selected_class_name : "",
    display_fare ? selected_fare_name : ""
  ]
    .filter(s => s && s.length)
    .join(", ");
}
